<template>
  <div class="content">
    <div class="channel" style="background-color: #000000;">
      <div class="regionTree">
        <tree
          :data="data"
          ref="region"
          :expanded="expanded"
          @handleNodeClick="handleNodeClick"
          style="height: 100%;width: 100%;"
        ></tree>
      </div>
      <div class="container" v-if="tabsMenu.length">
        <el-tabs class="tabLv3" type="border-card" v-model="tabName" @tab-click="tabclick">
          <i class="lt"></i>
          <i class="rt"></i>
          <template v-for="(i, index) of tabsMenu">
            <el-tab-pane
              :key="index"
              :name="i.id.toString()"
              :label="i.displayType + '/' + i.typeName"
            >
              <span slot="label">
                <i :class="'iconfont ' + i.icon"></i>
                <i class="border"></i>
                {{ i.typeName }}
              </span>
              <!-- <button class="sbzl BlueSmBtn" @click.stop="sbzl">
                设备总览
              </button> -->
              <div class="searchForm1" style="padding-right: 0; width: 100%;" :class="className">
                <el-form
                  :model="asearch"
                  ref="asearch"
                  style="margin-bottom:0;width: 100%;"
                  labelWidth="80"
                >
                  <el-form-item v-for="item of items" :key="item.prop" :label="item.label">
                    <el-select
                      v-model="asearch[item.prop]"
                      v-if="item.type === 'select'"
                      :popper-append-to-body="false"
                    >
                      <el-option
                        v-for="(i, index) of item.option"
                        :key="index"
                        :label="i.label"
                        :value="i.value"
                      ></el-option>
                    </el-select>
                    <el-input v-model="asearch[item.prop]" v-if="item.type === 'input'"></el-input>
                  </el-form-item>
                  <div
                    class="normalNav zaddBtn"
                    style="position: static;margin-top: 12px; width: 19%;text-align: center"
                  >
                    <button class="BlueSmBtn" @click="csearch">搜索</button>
                    <button class="OrangeSmBtn" @click="asearch = {}">重置</button>
                  </div>
                  <el-form-item label="是否告警" style="margin-top: 20px">
                    <el-select v-model="asearch.isAlarm" :popper-append-to-body="false">
                      <el-option label="是" :value="true"></el-option>
                      <el-option label="否" :value="false"></el-option>
                    </el-select>
                  </el-form-item>
                  <span class="collapseIcon" @click="className = 'expand'"
                    ><img
                      v-default-img
                      :src="require('../../public/searchForm/collapse.png')"
                      alt=""
                  /></span>
                  <span class="expandIcon" @click="className = 'collapse'"
                    ><img v-default-img :src="require('../../public/searchForm/expand.png')" alt=""
                  /></span>
                </el-form>
              </div>
            </el-tab-pane>
          </template>
        </el-tabs>
        <div class="main" style="padding-top:0" :class="className">
          <pages
            v-if="deviceType"
            ref="devicepages"
            :atabs="Number(deviceType)"
            :areaID="areaId + '' ? areaId + '' : data && data.length ? data[0].id + '' : ''"
            :appId="appId"
            :displayType="displayType"
            :name="{ pname: foo == null ? '' : foo.title, cname: cname }"
            :searchForm="searchForm"
          ></pages>
        </div>
      </div>
      <div class="without" v-else>
        <section :style="{ textAlign: 'center' }">
          <i class="iconfont iconshujuweikong" :style="{ fontSize: '40px' }"></i>
          <p>暂无数据</p>
        </section>
      </div>

      <template v-if="appId === 'waterPressureMonitoringSystem'">
        <gjjl
          v-if="systemType && deviceType"
          :areaId="areaId + ''"
          :menuFlag="systemType"
          :deviceType="deviceType"
        ></gjjl>
      </template>
      <template v-else>
        <div class="videoList" v-show="isShow" id="videoList">
          <header>联动视频</header>
          <div class="searchForm1" style="justify-content: center;">
            <el-form ref="cameraSearch" style="padding: 2% 0 0 0">
              <el-select
                v-model="cameraSearch"
                style="width: 100%; z-index:5555; margin: 5% 0px 0px 0px;"
                placeholder="请选择活动区域"
                @change="selectedCamera"
                :popper-append-to-body="false"
              >
                <el-option v-for="x of cameraItems" :value="x.id" :label="x.name" :key="x.id">{{
                  x.name
                }}</el-option>
              </el-select>
            </el-form>
          </div>
          <div class="videoBg" v-for="(i, index) in videoList">
            <div v-if="i.show" class="video">
              <videoPlayer
                :videoUrl="i.url"
                :id="i.deviceId"
                v-if="i.url"
                @openVideo="_openVideo"
              ></videoPlayer>
              <i
                style="
              color: #7e95c3;
              font-size: 20px;
              position: absolute;
              top: -15px;
              right: -15px;
            "
                class="iconfont iconguanbi7-01copy"
                @click="deleteVideo(index)"
              ></i>
            </div>
            <div v-else class="videoContent">
              <i
                style="color: #10f1e4; font-size: 24px;position: absolute; top: 14%; left: 50%;"
                class="iconfont iconbofang"
              ></i>
              <i
                style="
              color: #7e95c3;
              font-size: 20px;
              position: absolute;
              top: -80px;
              right: -15px;
            "
                class="iconfont iconguanbi7-01copy"
              ></i>
              <p><i class="iconfont iconmap"></i> 该位置可手动添加视频</p>
            </div>
            <p style="font-size: 12px; color: #c4d3f1; margin-bottom: 13px;margin-top: 13px">
              设备名称：{{ deviceDetail[index].name }}
            </p>
            <p style="font-size: 12px; color: #c4d3f1">
              设备地址：{{ deviceDetail[index].address }}
            </p>
          </div>
        </div>
        <div v-show="!isShow" class="videoListClose" @click="_closeDetail">
          <i class="iconfont iconleft"></i>
        </div>
      </template>

      <play-video v-if="videoId" :deviceId="videoId" @closeVideo="closeVideo"></play-video>
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'
  import videoPlayer from './video'
  export default {
    components: {
      normalNav: () => import('public/normalNav'),
      searchForm: () => import('public/searchForm'),
      easyTable: () => import('public/easyTable'),
      pages: () => import('./pages/index'),
      gjjl: () => import('./gjjl/index'),
      tree: () => import('../../public/regionTree/tree.vue'),
      videoPlayer,
      playVideo: () => import('./playVideo')
    },
    data() {
      return {
        className: 'collapse',
        data: [],
        expanded: [],
        tabName: '', //tabs绑定值
        loading: true,
        cameraItems: [
          {
            name: '请选择区域下摄像头',
            id: 0
          }
        ],
        cameraSearch: 0,
        isRepeat: true,
        items: [
          {
            type: 'select',
            prop: 'status',
            label: '设备状态',
            option: [
              {
                label: '在线',
                value: 1
              },
              {
                label: '离线',
                value: 2
              }
            ]
          },
          {
            type: 'input',
            prop: 'deviceName',
            label: '设备名称'
          },
          {
            type: 'input',
            prop: 'device_mark',
            label: '设备编码'
          }
          // {
          //   type: 'select',
          //   prop: 'isAlarm',
          //   label: '是否告警',
          //   option: [
          //     {
          //       label: '是',
          //       value: true,
          //     },
          //     {
          //       label: '否',
          //       value: false,
          //     },
          //   ],
          // },
        ],
        searchForm: {},
        asearch: {},
        tabsMenu: [],
        areaId: '',
        appId: '',
        deviceType: '',
        displayType: '',
        cname: '',
        videoActive: 0,
        isShow: true,
        videoId: null,
        videoList: [
          { id: 0, url: '', show: false, deviceId: 0 },
          { id: 1, url: '', show: false, deviceId: 0 }
        ],
        deviceDetail: [
          { name: '', address: '' },
          { name: '', address: '' }
        ]
      }
    },
    watch: {
      $route: {
        handler(to, from) {
          this.areaId = ''
          if (to.meta && to.meta.parent) {
            this.set_systemType(to.meta.parent + 'System')
            this.appId = this.systemType
            this.initArea()
            this.initTabs(this.systemType)
          } else {
            this.appId = this.systemType
            this.initArea()
            this.initTabs(this.systemType)
          }
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
      self() {
        return this
      },
      ...mapState(['menu']),
      ...mapState('deviceList', ['systemType', 'regionId', 'deviceId']),
      foo() {
        let a
        function fon(val, name) {
          val.forEach(i => {
            if (i.name === name) {
              a = i
              return
            } else {
              if (i.children && i.children.length) {
                fon(i.children, name)
              }
            }
          })
        }
        fon(this.menu, this.systemType)
        return a
      }
    },
    methods: {
      ...mapMutations('deviceList', ['set_area', 'set_deviceId', 'set_systemType']),
      ...mapMutations('continuing', ['changeArea', 'changeApp', 'changeDevice']),
      // 是否展示
      _closeDetail() {
        //this.isShow = !this.isShow;
      },
      _openVideo(id) {
        //this.isShow = false;
        this.videoId = id
      },
      // 关闭视频
      closeVideo() {
        this.videoId = ''
        this.isShow = true
      },
      // 关闭某个视频
      deleteVideo(i) {
        this.videoActive--
        this.videoList.splice(i, 1)
        for (var j = i; j < 1; j++) {
          this.videoList[j].id = j
        }
        this.videoList.push({ id: 1, url: '', show: false, deviceId: 0 })

        this.deviceDetail.splice(i, 1)
        this.deviceDetail.push({ name: '', address: '' })
      },
      // 打开视频
      async deviceInfo(e, dev) {
        // 展开
        this.isShow = true
        if (e === 'close') {
          return
        }
        // 重复
        if (!!this.videoList.find(item => item.deviceId == dev.deviceId)) {
          return
        }
        if (this.videoActive == 2) {
          return
        }
        // 打开视频
        this.videoActive++
        this.videoList[this.videoActive - 1].url = dev.video_url
        var ipAddr = window.location.href
        // console.log(' 当前请求 href:  '+ipAddr)
        if (0 > ipAddr.indexOf('192.168')) {
          // 如果是vpn环境
          // 改为vpn摄像头访问的地址
          if (dev != null && dev.standby_video_url != null) {
            this.videoList[this.videoActive - 1].url = dev.standby_video_url
          }
        }
        this.videoList[this.videoActive - 1].deviceId = dev.deviceId
        this.videoList[this.videoActive - 1].show = true
        // 获取设备信息
        let index = this.videoActive - 1
        this.$axiosget('operation/device/info?id=' + dev.deviceId).then(a => {
          this.deviceDetail[index].name = a.data.data.deviceName
          this.deviceDetail[index].address = a.data.data.address
        })
      },
      initCameraList(id) {
        // 关闭上次的摄像头
        if (this.videoActive > 0) {
          for (var i = 0; i < this.videoActive; i++) {
            this.videoList.splice(0, 1)
            this.videoList.push({ id: 1, url: '', show: false, deviceId: 0 })
            this.deviceDetail.splice(0, 1)
            this.deviceDetail.push({ name: '', address: '' })
          }
          this.videoActive = 0
        }

        this.cameraItems = [
          {
            name: '请选择区域下摄像头',
            id: 0
          }
        ]
        try {
          this.cameraSearch = 0
          this.$axiosget('operation/area/selectCameraByAreaId?areaId=' + id).then(res => {
            if (null != res.data.data) {
              this.cameraItems = res.data.data
              // 默认打开能找到的二个摄像头
              // console.log(this.cameraItems)
              // if (this.cameraItems.length >= 2) {
              //   this.$axiosget("operation/device/selectCameraMapByAreaId?areaId=" + this.cameraItems[0].id).then((res) => {
              //     if (null != res.data.data) {
              //       console.log(res.data.data)
              //       this.deviceInfo(null, res.data.data)
              //     }
              //   });
              //   this.$axiosget("operation/device/selectCameraMapByAreaId?areaId=" + this.cameraItems[1].id).then((res) => {
              //     if (null != res.data.data) {
              //       console.log(res.data.data)
              //       this.deviceInfo(null, res.data.data)
              //     }
              //   });
              // } else if (this.cameraItems.length == 1) {
              //   this.$axiosget("operation/device/selectCameraMapByAreaId?areaId=" + this.cameraItems[0].id).then((res) => {
              //     if (null != res.data.data) {
              //       console.log(res.data.data)
              //       this.deviceInfo(null, res.data.data)
              //     }
              //   });
              // }
            }
          })
        } catch (e) {}
      },
      // 选择摄像头
      selectedCamera() {
        // 找到设备，打开摄像头
        this.$axiosget('operation/device/selectCameraMapByAreaId?areaId=' + this.cameraSearch).then(
          res => {
            if (null != res.data.data) {
              this.deviceInfo(null, res.data.data)
            }
          }
        )
      },
      sbzl() {
        this.changeArea(this.regionId)
        this.changeApp(this.systemType)
        this.changeDevice(this.deviceId)
        this.$router.push(this.systemType)
      },
      handleNodeClick(data, node, vue) {
        this.areaId = data.id
        this.set_area(data.id)
        this.changeArea(data.id)
        // 初始化下拉框
        this.initCameraList(data.id)
      },
      tabclick(name, event) {
        console.log(name, event, '++++++')

        this.changeDevice(name.name)
        this.set_deviceId(name.name)
        let lable = name.label.split('/')
        this.deviceType = Number(name.name)
        this.displayType = lable[0]
        this.cname = lable[1]
      },
      // 条件查询
      csearch() {
        this.searchForm = { ...this.asearch }
      },
      initArea() {
        let that = this
        this.$axiosget(`operation/area/selectArea?menuFlag=${this.appId}`)
          .then(res => {
            that.data = res.data.data
            try {
              this.initCameraList(that.data[0].id)
            } catch (e) {}
            function transData(cur) {
              if (cur.areas) {
                cur.areas.forEach((area, i) => {
                  transData(area)
                })
                that.$set(
                  cur,
                  'children',
                  cur.areas.filter(area => area)
                )
                that.$delete(cur, 'areas')
              }
              that.$set(cur, 'label', cur.name)
              that.$delete(cur, 'name')
            }
            that.data.forEach((area, i) => {
              transData(area)
            })
            that.data = that.data.filter(area => area)
            // setTimeout(() => {
            //     // let ss = this.$route.query;
            //     this.$refs.region.$refs.tree.setCurrentKey(
            //         this.regionId ? this.regionId : this.data[0].areaId
            //     );
            //     this.expanded = [this.regionId ? this.regionId : this.data[0].areaId];
            // }, 1000);
          })
          .then(() => {
            that.$refs.region.$refs.tree.setCurrentKey(
              that.regionId ? that.regionId : that.data[0].areaId
            )
            that.expanded = [that.regionId ? that.regionId : that.data[0].areaId]
          })
      },

      initTabs(val) {
        console.log('this.systemType', this.systemType)

        if (val || this.systemType) {
          this.$axiosget('manager/operatingSystemApi/getDeviceTypeByOperatingMenuFlag', {
            params: {
              menuFlag: val ? val : this.systemType
            }
          }).then(res => {
            this.tabsMenu = res.data.data
            if (res.data.data.length && res.data.data) {
              let r = res.data.data
              let a = r.filter(i => i.id == this.deviceId)[0]
              a
                ? ((this.tabName = this.deviceType = a.id.toString()),
                  (this.displayType = a.displayType),
                  (this.cname = a.typeName))
                : ((this.tabName = this.deviceType = r[0].id.toString()),
                  (this.displayType = r[0].displayType),
                  (this.cname = r[0].typeName))
            }
          })
        }
      }
    },
    created() {
      ;[this.areaId, this.appId] = [this.regionId, this.systemType]
      console.log('刷新的时候', this.appId)
    },
    mounted() {
      // 初始化设备数据
    }
  }
</script>

<style scoped lang="less">
  .content {
    margin: 0;
    height: calc(100% - 20px);
    margin-top: 20px;
  }

  .channel {
    display: flex;
    height: 100%;
  }

  .channel .regionTree {
    width: 15%;
    padding: 0px 0px;
    height: calc(100% - 20px);
    outline: 1px solid #323d55;
  }

  .channel .regionTree .region {
    width: 15%;
    /* height: 100%; */
  }

  .channel .container {
    width: calc(100% - 35.5%);
    height: calc(100% - 20px);
    padding: 0px 0.5%;
  }

  .channel .container .searchForm1 .el-form {
    margin-bottom: 0 !important;
  }

  .searchForm1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-form {
      display: flex;
      justify-content: space-between;
      .el-form-item {
        width: 27%;
      }
    }
  }

  .collapse {
    .el-form-item {
      display: none;
    }

    .collapseIcon {
      display: block;
    }

    .expandIcon {
      display: none;
    }
  }

  .expand {
    .el-form-item {
      display: flex;
    }

    .expandIcon {
      display: block;
    }

    .collapseIcon {
      display: none;
    }
  }

  .channel .container .main {
    height: calc(100% - 150px);
    /* overflow: auto; */
    padding-top: 0 !important;
    position: relative;
  }

  .channel .container .expand {
    height: calc(100% - 204px);
  }

  .channel .without {
    width: calc(100% - 300px);
    height: calc(100% - 20px);
    color: #fff;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tableWrapper {
    padding: 10px;
    overflow-y: scroll;
    /* height: 600px; */
    height: calc(100% - 75px);
  }

  .tableWrapper::-webkit-scrollbar {
    display: none;
  }

  .container .el-tabs /deep/ .el-tabs__content {
    padding-bottom: 0;
  }

  .container .el-tabs /deep/ .el-tabs__content .zaddBtn {
    top: 9px !important;
  }

  .container .el-tabs /deep/ .el-tabs__content .sbzl {
    position: absolute;
    top: -42px;
    right: 32px;
    color: #fff;
    cursor: default;
    z-index: 100;
  }

  .content .videoList {
    position: absolute;
    right: 20px;
    // top: 50px;
    background: #0e1526cc;
    outline: 1px solid #323d55;
    width: 20%;
    height: 95%;
    //  z-index: 5033;
    padding: 0px 0px 0px 0px;
    .closeDetail {
      position: absolute;
      left: 5px;
      top: 50%;
      z-index: 345;
      color: #36bfffb8;
      width: 20px;
      height: 20px;
    }
    header {
      padding-left: 10px;
      padding-right: 10px;
      width: 100%;
      line-height: 52px;
      background: url('imgaes/1.png') no-repeat;
      background-size: cover;
      color: #ccc;
    }
    .videoBg {
      margin: 5% 3% 5% 1%;
      float: left;
      width: 98%;
      height: 38%;
      padding: 5px;
      background: #273652;
      box-sizing: border-box;
      .video {
        //margin-top: 30px;
        position: relative;
        height: calc(100% - 55px);
      }
      .videoContent {
        text-align: center;
        line-height: 150px;
        position: relative;
        width: 100%;
        height: calc(100% - 60px);
        background: url('imgaes/2.png');
        margin-bottom: 5px;
        p {
          width: 100%;
          position: absolute;
          bottom: 0;
          line-height: 30px;
          color: #7e95c3;
          background: #0e1526cc;
          font-size: 14px;
          padding-left: 10px;
          i {
            font-size: 14px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/devices/index.vue